import { uniqBy } from 'lodash';

import createReducer from 'shared/utils/createReducer';

import { HIDE_APPOINTMENT_INFO } from 'modules/queues/common/actions/appointmentInfo';
import { GET_TRANSLATIONS } from '../actions/getTranslations';

const defaultState = {
  translations: [],
};

export default createReducer(defaultState, {
  [GET_TRANSLATIONS.success]: (state, { payload }) => ({
    ...state,
    translations: uniqBy(payload.concat(state.translations), 'key'),
  }),

  [HIDE_APPOINTMENT_INFO]: () => defaultState,
});
